import RenewDomainForm from './RenewDomainForm';
import ConnectedRenewDomainForm from './ConnectedRenewDomainForm';

export { RenewDomainForm };
export default ConnectedRenewDomainForm;
